<style lang="scss" scoped>
</style>
<template>
  <div>
    <headerIndex 
      v-on:grid="currentView='grid'"
      v-on:list="currentView='list'"
    ></headerIndex>
    <template v-if="currentView == 'list' && path == '/luminarias'">
      <luminariaList></luminariaList>
    </template>
    <template v-if="currentView == 'grid' && path == '/luminarias'">
      <luminariaGrid></luminariaGrid>
    </template>
  </div>
</template>

<script>
export default {
  components: {
    headerIndex: () => import('@/components/headerIndex/headerIndex.vue'),
    luminariaList: () => import('./List.vue'),
    luminariaGrid: () => import('./Grid.vue')
  },
  data () {
    return {
      currentView: 'list',
      path: ''
    }
  },
  created () {
    this.path = this.$route.path
  }
}
</script>